import React, { useEffect, useState } from "react";
import { withStripePayment } from "../../../../../common/with-stripe-payment";
import {
  createPaymentIntent,
  getAllCardsAction,
  getPaymentIntentAction,
} from "../../../../../../redux/services/payments/paymentServices";
import { toastService } from "../../../../../common/toast-messages/toast";
import { useDispatch, useSelector } from "react-redux";
import {
  baseRouteMaker,
  routes,
} from "../../../../../../constants/routeConsts";
import { useNavigate } from "react-router-dom";
import Spinner from "../../../../../common/spinner/Spinner";
import WalletInfoPaymentDetails from "./WalletInfoPaymentDetails";
import { givePointsAction } from "../../../../../../redux/services/wallet-info/walletInfoServices";
import { useStripe } from "@stripe/react-stripe-js";

const Wallet = withStripePayment(WalletInfoPaymentDetails);

const WalletInfoPaymentForm = () => {

  const stripe = useStripe();

  /* loading dependencies */
  const [loading, setLoading] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  /* loading dependencies */

  /* dispatch an action */
  const dispatch = useDispatch();
  /* dispatch an action */

  /* navigation dependencies */
  const navigate = useNavigate();
  /* navigation dependencies */

  /* dialog dependencies */
  const [openPaymentConfirmationDialog, setOpenPaymentConfirmationDialog] =
    useState(false);
  /* dialog dependencies */

  const { loginDetails } = useSelector((state) => state.auth);

  const { selectedWalletInfoPlanDetails } = useSelector(
    (state) => state.walletInfo
  );

  const createPayment = async (
    newCardToken,
    selectedCard,
    resetDefaultFields
  ) => {

    const payment_method = selectedCard ? selectedCard : newCardToken?.card?.id;

    const dataToBeSent = {
      amount: selectedWalletInfoPlanDetails?.amount,
      currency: selectedWalletInfoPlanDetails.currency,
      order_id: null,
      event_type: selectedWalletInfoPlanDetails?.event_type,
      payment_method: payment_method,
      customer: loginDetails.customer_stripe_token,
      new_card: newCardToken?.id ? true : false,
      token_id: newCardToken?.id || null
    };

    dispatch(createPaymentIntent(dataToBeSent, setSubmitLoader)).then(
      (apiRes) => {
        const paymentIntentResponse = apiRes;
        confirmCardPayment(resetDefaultFields, paymentIntentResponse, payment_method)
      }
    );
  };

  /* fuction definition to confirm card payment */
  const confirmCardPayment = async (resetDefaultFields, paymentIntentResponse, payment_method) => {
    if(paymentIntentResponse && paymentIntentResponse.id) {
      if(paymentIntentResponse.status === 'requires_action'){
        try {
          const confirmData = await stripe.confirmCardPayment(paymentIntentResponse.client_secret, {
            payment_method: payment_method,
          });
          if (confirmData.paymentIntent) {
            const dataToBeSent = {
              paymentIntentId: confirmData.paymentIntent.id
            }
            dispatch(getPaymentIntentAction(dataToBeSent, setSubmitLoader)).then((apiRes)=>{
              handleStripeResponse(resetDefaultFields, apiRes);
            })
          } else {
            toastService.error(confirmData?.error?.message);
            setSubmitLoader(false);
          }
        } catch (e) {
          toastService.error('Payment failed :' + e.message);
          setSubmitLoader(false);
        }
      }
      else {
        handleStripeResponse(resetDefaultFields, paymentIntentResponse);
      }
    }
}
/* fuction definition to confirm card payment */

/* function definition to check the payment intent status */
const handleStripeResponse = (resetDefaultFields, paymentIntentResponse) => {
  if (paymentIntentResponse.status === 'succeeded' || paymentIntentResponse.status === 'processing') {
    createWalletPointsOrder(resetDefaultFields, paymentIntentResponse);
  }
  if (paymentIntentResponse.status === 'requires_payment_method') {
    toastService.error('Payment failed, please try again later');
    setSubmitLoader(false);
  }
}
/* function definition to check the payment intent status */

  const createWalletPointsOrder = async (
    resetDefaultFields,
    paymentIntentResponse
  ) => {
    // Take subscription plan details
    const dataToBeSent = {
      to_id: selectedWalletInfoPlanDetails?.to_id,
      source: "STRIPE",
      payment_intent_id: paymentIntentResponse?.id,
      amount: selectedWalletInfoPlanDetails?.amount,
      currency: selectedWalletInfoPlanDetails?.currency,
    };

    try {
      // Dispatch action to create subscription order
      await dispatch(givePointsAction(dataToBeSent, setSubmitLoader)).then(
        (apiRes) => {
          if (apiRes) {
            setOpenPaymentConfirmationDialog(true);
            resetDefaultFields();
          }
        }
      );
    } catch (error) {
      setSubmitLoader(false);
      toastService.error("Something went wrong!");
      console.error("Error creating subscription order:", error);
      // Handle the error (e.g., show an error message to the user)
    }
  };

  /* load initial card dependencies - get data of previously used card */
  useEffect(() => {
    if (
      Object.keys(selectedWalletInfoPlanDetails)?.length === 0 ||
      selectedWalletInfoPlanDetails === null ||
      selectedWalletInfoPlanDetails === undefined
    ) {
      navigate(baseRouteMaker(routes.DASHBOARD));
    }
    dispatch(getAllCardsAction(setLoading));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  /* load initial card dependencies - get data of previously used card */

  return loading ? (
    <Spinner />
  ) : (
    Object.keys(selectedWalletInfoPlanDetails)?.length !== 0 &&
      selectedWalletInfoPlanDetails !== null &&
      selectedWalletInfoPlanDetails !== undefined && (
        <Wallet
          submitLoader={submitLoader}
          createPayment={createPayment}
          openPaymentConfirmationDialog={openPaymentConfirmationDialog}
          setOpenPaymentConfirmationDialog={setOpenPaymentConfirmationDialog}
          applyCouponCode={false}
        />
      )
  );
};

export default WalletInfoPaymentForm;
